export function animateOnScroll() {
  const animateBlocks = document.querySelectorAll('.animate-on-visible');

  const getThreshold = (target) => {
    const regex = /threshold-(\d+)/;
    const match = target.className.match(regex);
    if (match) {
      return parseInt(match[1]) / 100
    }
    return 0.2
  }

  const pauseAllVideos = (exceptVideo) => {
    document.querySelectorAll('.run-video-on-scroll.playing video').forEach(video => {
      if (video !== exceptVideo) {
        video.pause();
        video.closest('.run-video-on-scroll').classList.remove('playing');
      }
    });
  };

  const handleVideoPlayback = (target) => {
    if (target.classList.contains('run-video-on-scroll')) {
      const video = target.querySelector('video');
      if (video) {
        // Pause other playing videos first
        pauseAllVideos(video);

        video.muted = true;
        video.play()
          .then(() => {
            target.classList.add('playing');
          })
          .catch(error => {
            console.log('Video playback failed:', error);
          });
      }
    }
  }

  const customisedObserver = target => {
    const threshold = getThreshold(target);

    return new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          handleVideoPlayback(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold });
  }

  animateBlocks.forEach((block) => {
    const targetObserver = customisedObserver(block);
    targetObserver.observe(block);
  });
}
